if (navigator.cookieEnabled) {
    let alerts = document.querySelectorAll('.alert');

    alerts.forEach(alert => {
        alert.addEventListener('click',
            event => {
                let target = event.target;
                let closeButton = target.closest ? target.closest('.alert-button') : target;

                if (closeButton && closeButton.classList && closeButton.classList.contains('alert-button')) {
                    alert.remove();
                    let closeDate = new Date(Date.now());
                    let closeDateISO = closeDate.toISOString();
                    let tomorrow = new Date();
                    tomorrow.setDate(tomorrow.getDate() + 1);
                    tomorrow.setHours(0);
                    tomorrow.setMinutes(0);
                    document.cookie = `alert=${closeDateISO};path=/;expires=${tomorrow.toUTCString()}`;
                }
            });
    });
}
